import React, {useEffect, useState} from "react";
import {
  Board,
  BoardHeader,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  CancelButton, ColSpan1,
  ColSpan2,
  ColSpan4, ColTitle,
  CustomDatePicker,
  DateContainer,
  RelativeDiv,
  RowSpan,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../../assets/GlobalStyles";
import {DEFAULT_DEMOGRAPHIC_TARGET, GENDER_OPTIONS, AGE_GROUP_OPTIONS} from "../entity/DemoGroup";
import {
  AdverInfo,
  CategoryItem,
  SelectCategory
} from "../styles/common";
import ko from "date-fns/locale/ko";
import {InventoryButton} from "../../../components/modal/InventorySettings";
import {Controller, useFormContext} from "react-hook-form";
import {useAtom} from "jotai";
import {stepCampaignAtom} from "../entity";
import {campaignBasicInfoAtom} from "../entity/Info";
import {
  selCampaignDemographicTarget,
  selGroupInfo,
  selMediaCategoryInfo,
  updateCampaignConfigInventory, updateCampaignDemographicTarget
} from "../../../services/campaign/GroupAxios";
import {
  campaignGroupInfoAtom,
  mediaCategoryAtom,
} from "../entity/Group";
import {dateFormat, toDay, unlimitedDate} from "../../../common/StringUtils";
import {selEnumInfo} from "../../../services/campaign/InfoAxios";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import {useResetAtom} from "jotai/utils";
import {campaignCreativeAtom} from "../entity/Creative";
import queryString from "query-string";
import store from "../../../store";
import {tokenResultAtom} from "../../login/entity/Common";
function CampaignTargetSetting({
  demographicTarget,
  setDemographicTarget,
  errors,
  clearErrors,
  isEditMode,
  onCancel
}) {
  const changeConfigType = (
      configField,
      valuesField,
      configType,
      errorField
  ) => {
    setDemographicTarget(prev => ({
      ...prev,
      [configField]: configType,
      [valuesField]:
          configType === 'ALL'
              ? []
              : prev[valuesField] ?? []
    }));

    clearErrors(errorField);
  };

  const toggleValue = (field, value, errorField) => {
    setDemographicTarget(prev => {
      const values = prev[field] ?? [];
      const selected = values.includes(value);

      return {
        ...prev,
        [field]: selected
            ? values.filter(item => item !== value)
            : [...values, value]
      };
    });

    clearErrors(errorField);
  };

  return (
      <>
        <Board>
          <BoardHeader>광고 타겟팅 정보 설정</BoardHeader>

          <BoardSearchResult>
            <RowSpan>
              <ColSpan4>
                <Span4>성별/연령 설정</Span4>
              </ColSpan4>
            </RowSpan>

            <RowSpan box={true} column={true}>
              <ColSpan4>
                <ColTitle>
                  <span>성별 타겟팅</span>
                </ColTitle>

                <RelativeDiv>
                  <ColSpan2>
                    <label>
                      <input
                          type="radio"
                          name="genderTargetConfigType"
                          checked={
                              demographicTarget.genderTargetConfigType ===
                              'ALL'
                          }
                          onChange={() =>
                              changeConfigType(
                                  'genderTargetConfigType',
                                  'genders',
                                  'ALL',
                                  'genderTarget'
                              )
                          }
                      />

                      <span>전체</span>
                    </label>

                    <label>
                      <input
                          type="radio"
                          name="genderTargetConfigType"
                          checked={
                              demographicTarget.genderTargetConfigType ===
                              'MANUAL'
                          }
                          onChange={() =>
                              changeConfigType(
                                  'genderTargetConfigType',
                                  'genders',
                                  'MANUAL',
                                  'genderTarget'
                              )
                          }
                      />

                      <span>직접 선택</span>
                    </label>
                  </ColSpan2>
                </RelativeDiv>
              </ColSpan4>

              {demographicTarget.genderTargetConfigType === 'MANUAL' && (
                  <ColSpan4>
                    <Span4 />

                    <RelativeDiv>
                      <SelectCategory>
                        {GENDER_OPTIONS.map(option => (
                            <CategoryItem
                                key={option.value}
                                active={
                                  demographicTarget.genders?.includes(
                                      option.value
                                  )
                                }
                                onClick={() =>
                                    toggleValue(
                                        'genders',
                                        option.value,
                                        'genderTarget'
                                    )
                                }
                            >
                              {option.label}
                            </CategoryItem>
                        ))}
                      </SelectCategory>

                      {errors.genderTarget && (
                          <ValidationScript
                              style={{position: 'unset'}}
                          >
                            {errors.genderTarget.message}
                          </ValidationScript>
                      )}
                    </RelativeDiv>
                  </ColSpan4>
              )}

              <ColSpan4>
                <ColTitle>
                  <span>연령 타겟팅</span>
                </ColTitle>

                <RelativeDiv>
                  <ColSpan2>
                    <label>
                      <input
                          type="radio"
                          name="ageTargetConfigType"
                          checked={
                              demographicTarget.ageTargetConfigType === 'ALL'
                          }
                          onChange={() =>
                              changeConfigType(
                                  'ageTargetConfigType',
                                  'ageGroups',
                                  'ALL',
                                  'ageTarget'
                              )
                          }
                      />

                      <span>전체</span>
                    </label>

                    <label>
                      <input
                          type="radio"
                          name="ageTargetConfigType"
                          checked={
                              demographicTarget.ageTargetConfigType ===
                              'MANUAL'
                          }
                          onChange={() =>
                              changeConfigType(
                                  'ageTargetConfigType',
                                  'ageGroups',
                                  'MANUAL',
                                  'ageTarget'
                              )
                          }
                      />

                      <span>직접 선택</span>
                    </label>
                  </ColSpan2>
                </RelativeDiv>
              </ColSpan4>

              {demographicTarget.ageTargetConfigType === 'MANUAL' && (
                  <ColSpan4>
                    <Span4 />

                    <RelativeDiv>
                      <SelectCategory>
                        {AGE_GROUP_OPTIONS.map(option => (
                            <CategoryItem
                                key={option.value}
                                active={
                                  demographicTarget.ageGroups?.includes(
                                      option.value
                                  )
                                }
                                onClick={() =>
                                    toggleValue(
                                        'ageGroups',
                                        option.value,
                                        'ageTarget'
                                    )
                                }
                            >
                              {option.label}
                            </CategoryItem>
                        ))}
                      </SelectCategory>

                      {errors.ageTarget && (
                          <ValidationScript
                              style={{position: 'unset'}}
                          >
                            {errors.ageTarget.message}
                          </ValidationScript>
                      )}
                    </RelativeDiv>
                  </ColSpan4>
              )}
            </RowSpan>
          </BoardSearchResult>
        </Board>

        <SubmitContainer>
          <CancelButton
              type="button"
              onClick={onCancel}
          >
            {isEditMode ? '목록' : '이전'}
          </CancelButton>

          <SubmitButton type="submit">
            {isEditMode ? '수정' : '다음[3/4]'}
          </SubmitButton>
        </SubmitContainer>
      </>
  );
}
function CampaignGroupSetting({
  isEditMode,
  adverInfo,
  campaignGroupInfo,
  mediaCategory,
  exposureDayChecked,
  dateRange,
  startDate,
  endDate,
  control,
  errors,
  setExposureInventoryType,
  selectedCategory,
  selectedDisExposureCategory,
  handleRangeDate,
  handleCheckExposureDay
}) {
  return (
      <>
        {isEditMode && (
            <AdverInfo>
              <span>광고주 정보</span>
              <p />
              <span>{adverInfo}</span>
            </AdverInfo>
        )}

        <Board>
          <BoardHeader>광고 그룹 설정</BoardHeader>

          <BoardSearchResult>
            <RowSpan>
              <ColSpan4>
                <Span4>광고 게재 설정</Span4>
              </ColSpan4>
            </RowSpan>

            <RowSpan box={true} column={true}>
              <ColSpan4>
                <ColTitle>
                  <span>게재 지면</span>
                </ColTitle>

                <RelativeDiv>
                  <ColSpan2>
                    <label>
                      <Controller
                          name="inventoryNONE"
                          control={control}
                          render={({field}) => (
                              <input
                                  {...field}
                                  type="radio"
                                  name="inventory"
                                  id="inventoryNONE"
                                  onChange={() => {
                                    field.onChange('NONE');
                                    setExposureInventoryType('NONE');
                                  }}
                                  checked={
                                      campaignGroupInfo?.exposureInventoryType ===
                                      'NONE'
                                  }
                              />
                          )}
                      />

                      <span>미선택</span>
                    </label>

                    <label>
                      <Controller
                          name="inventoryMANUAL"
                          control={control}
                          rules={{
                            required: {
                              value:
                                  campaignGroupInfo?.exposureInventoryType ===
                                  'MANUAL' &&
                                  (campaignGroupInfo?.allowInventoryIds?.length ??
                                      0) === 0,
                              message: '지면을 선택해주세요.'
                            }
                          }}
                          render={({field}) => (
                              <input
                                  {...field}
                                  type="radio"
                                  name="inventory"
                                  id="inventoryMANUAL"
                                  onChange={() => {
                                    field.onChange('MANUAL');
                                    setExposureInventoryType('MANUAL');
                                  }}
                                  checked={
                                      campaignGroupInfo?.exposureInventoryType ===
                                      'MANUAL'
                                  }
                              />
                          )}
                      />

                      <span>직접 선택</span>
                    </label>

                    {campaignGroupInfo?.exposureInventoryType ===
                        'MANUAL' && (
                            <InventoryButton
                                title="게재 지면 설정"
                                buttonText="지면선택"
                                type="allow"
                            />
                        )}

                    {campaignGroupInfo?.exposureInventoryType ===
                        'MANUAL' &&
                        (campaignGroupInfo?.allowInventoryIds?.length ?? 0) >
                        0 && (
                            <small>
                              {campaignGroupInfo.allowInventoryIds.length}개 지면
                              송출 설정
                            </small>
                        )}

                    {errors.inventoryMANUAL &&
                        (campaignGroupInfo?.allowInventoryIds?.length ?? 0) ===
                        0 && (
                            <small>
                              <ValidationScript
                                  style={{position: 'unset'}}
                              >
                                {errors.inventoryMANUAL.message}
                              </ValidationScript>
                            </small>
                        )}
                  </ColSpan2>
                </RelativeDiv>
              </ColSpan4>

              {campaignGroupInfo?.exposureInventoryType === 'CATEGORY' && (
                  <ColSpan4>
                    <Span4 />

                    <RelativeDiv>
                      <SelectCategory>
                        {mediaCategory?.data?.map(item => (
                            <CategoryItem
                                key={item.value}
                                active={
                                  campaignGroupInfo?.allowInventoryCategories
                                  ?.includes(item.value)
                                }
                                onClick={() => selectedCategory(item.value)}
                            >
                              {item.label}
                            </CategoryItem>
                        ))}
                      </SelectCategory>

                      {errors.inventoryCATEGORY && (
                          <small>
                            <ValidationScript>
                              {errors.inventoryCATEGORY.message}
                            </ValidationScript>
                          </small>
                      )}
                    </RelativeDiv>
                  </ColSpan4>
              )}

              {campaignGroupInfo?.disExposureInventoryType ===
                  'CATEGORY' && (
                      <ColSpan4>
                        <Span4 />

                        <RelativeDiv>
                          <SelectCategory>
                            {mediaCategory?.data?.map(item => (
                                <CategoryItem
                                    key={item.value}
                                    active={
                                      campaignGroupInfo?.disAllowInventoryCategories
                                      ?.includes(item.value)
                                    }
                                    onClick={() =>
                                        selectedDisExposureCategory(item.value)
                                    }
                                >
                                  {item.label}
                                </CategoryItem>
                            ))}
                          </SelectCategory>

                          {errors.disInventoryCATEGORY && (
                              <ValidationScript>
                                {errors.disInventoryCATEGORY.message}
                              </ValidationScript>
                          )}
                        </RelativeDiv>
                      </ColSpan4>
                  )}

              {campaignGroupInfo?.exposureInventoryType !== 'NONE' && (
                  <RowSpan
                      validation
                      style={{justifyContent: 'flex-start'}}
                  >
                    <ColSpan1>
                      <ColTitle>
                        <span>게재 기간</span>
                      </ColTitle>

                      <DateContainer>
                        <CalendarBox>
                          <CalendarIcon />
                        </CalendarBox>

                        <Controller
                            control={control}
                            name="endDate"
                            rules={{
                              required: {
                                value: exposureDayChecked
                                    ? dateRange[0] == null
                                    : dateRange[1] == null,
                                message: '게재 기간을 설정해주세요.'
                              }
                            }}
                            render={({field: {onBlur, ref}}) => (
                                <CustomDatePicker
                                    selectsRange={!exposureDayChecked}
                                    startDate={startDate}
                                    endDate={endDate}
                                    placeholderText="날짜를 입력해 주세요."
                                    minDate={new Date()}
                                    onChange={handleRangeDate}
                                    dateFormat="yyyy-MM-dd"
                                    locale={ko}
                                    isClearable={false}
                                    onBlur={onBlur}
                                    selected={startDate}
                                    inputRef={ref}
                                    monthsShown={2}
                                    openToDate={startDate}
                                />
                            )}
                        />

                        {errors.endDate && (
                            <ValidationScript>
                              {errors.endDate.message}
                            </ValidationScript>
                        )}
                      </DateContainer>
                    </ColSpan1>

                    <ColSpan1>
                      <label>
                        <input
                            type="checkbox"
                            className="checkbox-type-a"
                            checked={exposureDayChecked}
                            onChange={handleCheckExposureDay}
                        />

                        <i />
                        <span>종료일 미설정</span>
                      </label>
                    </ColSpan1>
                  </RowSpan>
              )}
            </RowSpan>
          </BoardSearchResult>
        </Board>
      </>
  );
}
export function CampaignThree() {
  const [, setStepCampaign] = useAtom(stepCampaignAtom);
  const [campaignBasicInfo, setCampaignBasicInfo] = useAtom(campaignBasicInfoAtom);
  const [campaignGroupInfo, setCampaignGroupInfo] = useAtom(campaignGroupInfoAtom);
  const [exposureDayChecked, setExposureDayChecked] = useState(false);
  const [mediaCategory, setMediaCategory] = useAtom(mediaCategoryAtom);
  const [, setAgentTypeState] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [startDate, endDate] = dateRange;
  const {
    handleSubmit,
    reset,
    setValue,
    setError,
    control,
    formState: {errors},
    clearErrors
  } = useFormContext();
  const location = useLocation();
  const navigate = useNavigate();
  const resetCreativeInfo = useResetAtom(campaignCreativeAtom);
  const [demographicTarget, setDemographicTarget] = useState(
      DEFAULT_DEMOGRAPHIC_TARGET
  );

  useEffect(() => {
    selMediaCategoryInfo().then(response => {
      if (response) {
        setMediaCategory(response)
      }
    });

    selEnumInfo('AGENT_TYPE').then(response => {
      setAgentTypeState(response.values)
    });
  }, [])

  useEffect(() => {
    if ((state !== null || ['STEP3_INVENTORY', 'STEP4_CREATIVE', 'COMPLETED'].includes(campaignBasicInfo.step))) {
      let campaignId = state !== null ? state.campaignId : campaignBasicInfo.campaignId;

      if(campaignId !== '') {
        setCampaignGroupInfo({
          ...campaignGroupInfo,
          campaignId: campaignId
        })
      }
      Promise.all([
        selGroupInfo(campaignId),
        selCampaignDemographicTarget(campaignId)
      ]).then(([groupResponse, demographicResponse]) => {
        if (groupResponse != null) {
          setCampaignGroupInfo(groupResponse);
          reset({name: groupResponse.name});

          setExposureDayChecked(
              groupResponse.endDate === '3000-12-31'
          );

          setDateRange([
            new Date(groupResponse.startDate),
            groupResponse.endDate !== '3000-12-31'
                ? new Date(groupResponse.endDate)
                : null
          ]);
        }

        setDemographicTarget({
          ...DEFAULT_DEMOGRAPHIC_TARGET,
          genderTargetConfigType:
              demographicResponse?.genderTargetConfigType
              ?? DEFAULT_DEMOGRAPHIC_TARGET.genderTargetConfigType,
          genders:
              demographicResponse?.genders
              ?? DEFAULT_DEMOGRAPHIC_TARGET.genders,
          ageTargetConfigType:
              demographicResponse?.ageTargetConfigType
              ?? DEFAULT_DEMOGRAPHIC_TARGET.ageTargetConfigType,
          ageGroups:
              demographicResponse?.ageGroups
              ?? DEFAULT_DEMOGRAPHIC_TARGET.ageGroups
        });
      });
    } else {
      let time = dateFormat(toDay(), 'YYMMDDHHmm');
      let name = campaignBasicInfo.productType !== 'BANNER' ? 'GR_PU_' + time
          : 'GR_BA_' + time
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        name: name
      })
      setValue('name', name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state])

  useEffect(() => {
    if (dateRange?.length !== 0) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        startDate: dateFormat(startDate, 'YYYY-MM-DD'),
        endDate: dateFormat(endDate, 'YYYY-MM-DD'),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange])

  const selectedCategory = (selectedCategory) => {
    let boolCategory = campaignGroupInfo.allowInventoryCategories.includes(
        selectedCategory)
    if (!boolCategory) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        allowInventoryCategories: campaignGroupInfo.allowInventoryCategories.concat(
            selectedCategory)
      })
    } else {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        allowInventoryCategories: campaignGroupInfo.allowInventoryCategories.filter(
            value => value !== selectedCategory)
      })
    }
    clearErrors('inventoryCATEGORY')
  }
  const selectedDisExposureCategory = (selectedCategory) => {
    let boolCategory = campaignGroupInfo.disAllowInventoryCategories.includes(
        selectedCategory)
    if (!boolCategory) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        disAllowInventoryCategories: campaignGroupInfo.disAllowInventoryCategories.concat(
            selectedCategory)
      })
    } else {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        disAllowInventoryCategories: campaignGroupInfo.disAllowInventoryCategories.filter(
            value => value !== selectedCategory)
      })
    }
    clearErrors('disInventoryCATEGORY')
  }

  const setExposureInventoryType = (exposureInventoryType) => {
    setCampaignGroupInfo({
      ...campaignGroupInfo,
      exposureInventoryType: exposureInventoryType,
      allowInventoryCategories: [],
      allowInventoryIds: []
    })
    clearErrors('inventoryCATEGORY')
    clearErrors('inventoryMANUAL')
  }

  const handleRangeDate = (date) => {
    if (date?.length !== undefined) {
      setDateRange(date)
    } else {
      setDateRange([date, null])
    }

    clearErrors('endDate')
  }

  const handleCheckExposureDay = (event) => {
    setExposureDayChecked(event.target.checked)
    if (event.target.checked && startDate !== null) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        endDate: '3000-12-31'
      })
      setDateRange([startDate, null])
    } else {
      setDateRange([null, null])
    }
  }

  const onCancel = () => {
    if (isEditMode) {
      navigate('/board/manageCreative', {
        replace: true
      });
      return;
    }

    setStepCampaign({steps: 1});
  };
  const onSubmit = async () => {
    if (!validateDemographicTarget()) {
      return;
    }

    const campaignId =
        state?.campaignId ?? campaignBasicInfo.campaignId;

    const time = dateFormat(toDay(), 'YYMMDDHHmm');
    const name =
        campaignBasicInfo.productType !== 'BANNER'
            ? `GR_PU_${time}`
            : `GR_BA_${time}`;

    const isInventoryNone =
        campaignGroupInfo.exposureInventoryType === 'NONE';

    const inventoryParam = {
      ...campaignGroupInfo,
      campaignId,
      name,
      startDate: isInventoryNone
          ? dateFormat(toDay(), 'YYYY-MM-DD')
          : campaignGroupInfo.startDate,

      endDate: isInventoryNone
          ? unlimitedDate('YYYY-MM-DD')
          : exposureDayChecked
              ? unlimitedDate('YYYY-MM-DD')
              : endDate
    };

    // 먼저 전체 validation 처리
    if (!isInventoryNone && !inventoryParam.endDate) {
      setError('endDate', {
        type: 'required',
        message: '게재 기간을 선택해주세요.'
      });

      return;
    }

    const demographicParam = {
      campaignId,
      genderTargetConfigType:
      demographicTarget.genderTargetConfigType,
      genders:
          demographicTarget.genderTargetConfigType === 'ALL'
              ? []
              : demographicTarget.genders,
      ageTargetConfigType:
      demographicTarget.ageTargetConfigType,
      ageGroups:
          demographicTarget.ageTargetConfigType === 'ALL'
              ? []
              : demographicTarget.ageGroups
    };

    try {
      const [inventoryResult, demographicResult] = await Promise.all([
        updateCampaignConfigInventory(inventoryParam),
        updateCampaignDemographicTarget(demographicParam)
      ]);

      if (!inventoryResult || !demographicResult) {
        toast.error('광고 그룹 설정 저장 중 오류가 발생했습니다.', {
          toastId: 'updateCampaignConfigError'
        });
        return;
      }

      resetCreativeInfo();

      if (state?.campaignId) {
        toast.success('수정되었습니다.', {
          autoClose: 500,
          toastId: 'updateCampaignConfig'
        });
        console.log(
            'navigate 전 token:',
            store.get(tokenResultAtom)
        );
        navigate('/board/manageCreative', {
          replace: true
        });

        return;
      }

      if (
          !['STEP3_INVENTORY', 'STEP4_CREATIVE', 'COMPLETED'].includes(
              campaignBasicInfo.step
          )
      ) {
        setCampaignBasicInfo(prev => ({
          ...prev,
          step: 'STEP3_INVENTORY'
        }));
      }

      setStepCampaign({steps: 3});
    } catch (error) {
      console.error(error);

      toast.error('광고 그룹 설정 저장 중 오류가 발생했습니다.', {
        toastId: 'updateCampaignConfigError'
      });
    }
  };
  const validateDemographicTarget = () => {
    let valid = true;

    clearErrors(['genderTarget', 'ageTarget']);

    if (
        demographicTarget.genderTargetConfigType === 'MANUAL' &&
        demographicTarget.genders.length === 0
    ) {
      setError('genderTarget', {
        type: 'required',
        message: '성별을 하나 이상 선택해주세요.'
      });

      valid = false;
    }

    if (
        demographicTarget.ageTargetConfigType === 'MANUAL' &&
        demographicTarget.ageGroups.length === 0
    ) {
      setError('ageTarget', {
        type: 'required',
        message: '연령대를 하나 이상 선택해주세요.'
      });

      valid = false;
    }

    return valid;
  };
  const onError = (error) => console.log(error)
  const state =
      location.search !== ''
          ? queryString.parse(location.search)
          : location.state;

  const isEditMode = Boolean(state?.campaignId);
  return (
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <CampaignGroupSetting
            isEditMode={isEditMode}
            adverInfo={state?.adverInfo}
            campaignGroupInfo={campaignGroupInfo}
            mediaCategory={mediaCategory}
            exposureDayChecked={exposureDayChecked}
            dateRange={dateRange}
            startDate={startDate}
            endDate={endDate}
            control={control}
            errors={errors}
            setExposureInventoryType={setExposureInventoryType}
            selectedCategory={selectedCategory}
            selectedDisExposureCategory={
              selectedDisExposureCategory
            }
            handleRangeDate={handleRangeDate}
            handleCheckExposureDay={handleCheckExposureDay}
        />

        <CampaignTargetSetting
            demographicTarget={demographicTarget}
            setDemographicTarget={setDemographicTarget}
            errors={errors}
            clearErrors={clearErrors}
            isEditMode={isEditMode}
            onCancel={onCancel}
        />
      </form>
  );
}